/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters } from "../../funcs/v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters:
  ToolDefinition = {
    name: "v4-boundary-get-api-v4-boundary-node-data-centers",
    description: ``,
    tool: async (client, ctx) => {
      const [result, apiCall] =
        await v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters(
          client,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
